import {useCallback, useEffect, useRef} from "react";
import {FieldErrors} from "react-hook-form";

import {IAppError} from "@pg-mono/request-state";

import {useAppSelector} from "../../store/hooks";
import {getLeadFormFieldErrorsMap} from "../tracking/amplitude/collect_lead_form_field_error_paths";
import {trackAmplitudeLeadFormError} from "../tracking/amplitude/track_amplitude_lead_form_events";
import {IApplicationReducerData} from "../types/IApplicationReducerData";

interface IProps {
    /** `formState.errors` of the lead form - read on every render, so the hook sees each new error. */
    formErrors: FieldErrors;
    leadData: IApplicationReducerData | undefined;
}

interface IUseLeadFormErrorTrackingReturn {
    /** Submit attempt blocked by validation - the only validation case that carries `cta_text`. */
    trackInvalidSubmit: (errors: FieldErrors, ctaText: string | null) => void;
    /** API failure of the lead submit (registration, profile sync, application create). */
    trackApiError: (appError: IAppError) => void;
    /** Marks fields as already reported, so the same error isn't reported again once `setError` runs. */
    markFieldErrorsReported: (fieldErrors: Record<string, string>) => void;
}

/**
 * Amplitude `lead_form_error` (spec DSA-A-61) for a single lead form. On RP the event is also sent for
 * field validation errors surfaced without a CTA click - those carry no `cta_text`.
 */
export const useLeadFormErrorTracking = (props: IProps): IUseLeadFormErrorTrackingReturn => {
    const {formErrors, leadData} = props;

    const amplitudeLeadFormEventTracking = useAppSelector((state) => state.mainLead.amplitudeLeadFormEventTracking);
    const source = useAppSelector((state) => state.mainLead.source);
    const sourceSection = useAppSelector((state) => state.mainLead.sourceSection);

    const trackedFieldErrorsRef = useRef<Record<string, string>>({});

    /** Returns `false` when the tracking context isn't available yet, so the error can be reported later. */
    const trackFieldErrors = useCallback(
        (errors: FieldErrors, ctaText: string | null): boolean => {
            if (!amplitudeLeadFormEventTracking || !leadData || source == null || sourceSection == null) {
                return false;
            }

            trackAmplitudeLeadFormError({
                trackingContext: amplitudeLeadFormEventTracking,
                leadData,
                source,
                sourceSection,
                fieldErrors: errors,
                ctaText
            });

            return true;
        },
        [amplitudeLeadFormEventTracking, leadData, source, sourceSection]
    );

    const trackApiError = useCallback(
        (appError: IAppError) => {
            if (!amplitudeLeadFormEventTracking || !leadData || source == null || sourceSection == null) {
                return;
            }

            trackAmplitudeLeadFormError({
                trackingContext: amplitudeLeadFormEventTracking,
                leadData,
                source,
                sourceSection,
                appError
            });
        },
        [amplitudeLeadFormEventTracking, leadData, source, sourceSection]
    );

    const markFieldErrorsReported = useCallback((fieldErrors: Record<string, string>) => {
        trackedFieldErrorsRef.current = {...trackedFieldErrorsRef.current, ...fieldErrors};
    }, []);

    const trackInvalidSubmit = useCallback(
        (errors: FieldErrors, ctaText: string | null) => {
            // A submit attempt always reports, even for errors already reported while the user was filling
            // the form in: clicking the CTA despite a visible error is a distinct signal.
            if (trackFieldErrors(errors, ctaText)) {
                trackedFieldErrorsRef.current = getLeadFormFieldErrorsMap(errors);
            }
        },
        [trackFieldErrors]
    );

    // Validation errors surfaced without a CTA click - on field change (`mode: "onChange"`) or via
    // `setError` (e.g. the email verification API).
    //
    // Keyed on a signature of the current errors, NOT on `formState.errors` itself: react-hook-form
    // mutates that object in place, so its identity never changes for field-level validation and an
    // effect depending on it would never re-run (RP-771).
    const fieldErrorsMap = getLeadFormFieldErrorsMap(formErrors);
    const fieldErrorsSignature = Object.entries(fieldErrorsMap)
        .map(([fieldName, message]) => `${fieldName}:${message}`)
        .join("|");

    useEffect(() => {
        if (!fieldErrorsSignature) {
            trackedFieldErrorsRef.current = {};
            return;
        }

        const hasUnreportedError = Object.entries(fieldErrorsMap).some(([fieldName, message]) => trackedFieldErrorsRef.current[fieldName] !== message);

        if (!hasUnreportedError) {
            trackedFieldErrorsRef.current = fieldErrorsMap;
            return;
        }

        // No CTA click involved - `cta_text` stays empty (spec DSA-A-61).
        if (trackFieldErrors(formErrors, null)) {
            trackedFieldErrorsRef.current = fieldErrorsMap;
        }
    }, [fieldErrorsSignature, trackFieldErrors]);

    return {trackInvalidSubmit, trackApiError, markFieldErrorsReported};
};
import {useCallback, useEffect, useRef} from "react";
import {FieldErrors} from "react-hook-form";

import {IAppError} from "@pg-mono/request-state";

import {useAppSelector} from "../../store/hooks";
import {getLeadFormFieldErrorsMap} from "../tracking/amplitude/collect_lead_form_field_error_paths";
import {trackAmplitudeLeadFormError} from "../tracking/amplitude/track_amplitude_lead_form_events";
import {IApplicationReducerData} from "../types/IApplicationReducerData";

interface IProps {
    /** `formState.errors` of the lead form - read on every render, so the hook sees each new error. */
    formErrors: FieldErrors;
    leadData: IApplicationReducerData | undefined;
}

interface IUseLeadFormErrorTrackingReturn {
    /** Submit attempt blocked by validation - the only validation case that carries `cta_text`. */
    trackInvalidSubmit: (errors: FieldErrors, ctaText: string | null) => void;
    /** API failure of the lead submit (registration, profile sync, application create). */
    trackApiError: (appError: IAppError) => void;
    /** Marks fields as already reported, so the same error isn't reported again once `setError` runs. */
    markFieldErrorsReported: (fieldErrors: Record<string, string>) => void;
}

/**
 * Amplitude `lead_form_error` (spec DSA-A-61) for a single lead form. On RP the event is also sent for
 * field validation errors surfaced without a CTA click - those carry no `cta_text`.
 */
export const useLeadFormErrorTracking = (props: IProps): IUseLeadFormErrorTrackingReturn => {
    const {formErrors, leadData} = props;

    const amplitudeLeadFormEventTracking = useAppSelector((state) => state.mainLead.amplitudeLeadFormEventTracking);
    const source = useAppSelector((state) => state.mainLead.source);
    const sourceSection = useAppSelector((state) => state.mainLead.sourceSection);

    const trackedFieldErrorsRef = useRef<Record<string, string>>({});

    /** Returns `false` when the tracking context isn't available yet, so the error can be reported later. */
    const trackFieldErrors = useCallback(
        (errors: FieldErrors, ctaText: string | null): boolean => {
            if (!amplitudeLeadFormEventTracking || !leadData || source == null || sourceSection == null) {
                return false;
            }

            trackAmplitudeLeadFormError({
                trackingContext: amplitudeLeadFormEventTracking,
                leadData,
                source,
                sourceSection,
                fieldErrors: errors,
                ctaText
            });

            return true;
        },
        [amplitudeLeadFormEventTracking, leadData, source, sourceSection]
    );

    const trackApiError = useCallback(
        (appError: IAppError) => {
            if (!amplitudeLeadFormEventTracking || !leadData || source == null || sourceSection == null) {
                return;
            }

            trackAmplitudeLeadFormError({
                trackingContext: amplitudeLeadFormEventTracking,
                leadData,
                source,
                sourceSection,
                appError
            });
        },
        [amplitudeLeadFormEventTracking, leadData, source, sourceSection]
    );

    const markFieldErrorsReported = useCallback((fieldErrors: Record<string, string>) => {
        trackedFieldErrorsRef.current = {...trackedFieldErrorsRef.current, ...fieldErrors};
    }, []);

    const trackInvalidSubmit = useCallback(
        (errors: FieldErrors, ctaText: string | null) => {
            // A submit attempt always reports, even for errors already reported while the user was filling
            // the form in: clicking the CTA despite a visible error is a distinct signal.
            if (trackFieldErrors(errors, ctaText)) {
                trackedFieldErrorsRef.current = getLeadFormFieldErrorsMap(errors);
            }
        },
        [trackFieldErrors]
    );

    // Validation errors surfaced without a CTA click - on field change (`mode: "onChange"`) or via
    // `setError` (e.g. the email verification API).
    //
    // Keyed on a signature of the current errors, NOT on `formState.errors` itself: react-hook-form
    // mutates that object in place, so its identity never changes for field-level validation and an
    // effect depending on it would never re-run (RP-771).
    const fieldErrorsMap = getLeadFormFieldErrorsMap(formErrors);
    const fieldErrorsSignature = Object.entries(fieldErrorsMap)
        .map(([fieldName, message]) => `${fieldName}:${message}`)
        .join("|");

    useEffect(() => {
        if (!fieldErrorsSignature) {
            trackedFieldErrorsRef.current = {};
            return;
        }

        const hasUnreportedError = Object.entries(fieldErrorsMap).some(([fieldName, message]) => trackedFieldErrorsRef.current[fieldName] !== message);

        if (!hasUnreportedError) {
            trackedFieldErrorsRef.current = fieldErrorsMap;
            return;
        }

        // No CTA click involved - `cta_text` stays empty (spec DSA-A-61).
        if (trackFieldErrors(formErrors, null)) {
            trackedFieldErrorsRef.current = fieldErrorsMap;
        }
    }, [fieldErrorsSignature, trackFieldErrors]);

    return {trackInvalidSubmit, trackApiError, markFieldErrorsReported};
};
